import { Routes } from "@angular/router";
import { Environment as env } from "@amwager/util-ts";
import { accessGuardRouteFn } from "@amwager/data-access";
import { WagerComponent } from "./components/wager/wager.component";
import { ResultsComponent } from "./components/results/results.component";
import { ReplaysAndSearchComponent } from "./components/replays-and-search/replays-and-search.component";
import { ProgramComponent } from "./components/program/program.component";



export const originalRoutes: Routes = [
  {
    path: 'wager',
    component: WagerComponent,
    canActivate: [accessGuardRouteFn],
    title: 'Wager',
  },
  {
    path: 'results',
    component: ResultsComponent,
    canActivate: [accessGuardRouteFn],
    title: 'Results',
  },
  {
    path: 'replays',
    component: ReplaysAndSearchComponent,
    canActivate: [accessGuardRouteFn],
    title: 'Replays',
  },
  {
    path: 'program',
    component: ProgramComponent,
    canActivate: [accessGuardRouteFn],
    title: 'Program',
  },
];

export const testRoutes: Routes = [
  {
    path: 'wager/test',
    component: WagerComponent,
    title: 'Wager',
  },
  {
    path: 'results/test',
    component: ResultsComponent,
    title: 'Results',
  },
  {
    path: 'replays/test',
    component: ReplaysAndSearchComponent,
    title: 'Replays',
  },
  {
    path: 'program/test',
    component: ProgramComponent,
    title: 'Program',
  },
];

export const routes: Routes = env.Environment.enableComponentView
  ? [ ...originalRoutes, ...testRoutes ]
  : [ ...originalRoutes ]
;
